import { post, get, applyFilterUrl } from "../../../misc/api";
import { promiseImage } from "../../../misc/utils";

export const uploadToFilter = async images => {
  try {
    let src;
    if (images.crop && images.crop.src) {
      src = images.crop.src;
    } else {
      const canvas = document.getElementById("canvas1");
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        await promiseImage(images),
        0,
        0,
        canvas.width,
        canvas.height
      );
      src = canvas.toDataURL();
    }
    const response = await post("filters", { src });
    return response.s3key;
  } catch (err) {
    console.error(err);
  }
};

export const applyFilter = async (s3key, filter) => {
  const url = `${process.env.REACT_APP_SCREENSHOT_URL}?url=${applyFilterUrl}/${s3key}`;
  return get(`${url}/${filter}`);
};



// WEBPACK FOOTER //
// ./src/components/areas/EditorFilter/actions.js